module.exports = __webpack_public_path__ + "img/titleC.2d5fc9ea.png";